import React, { useState, useEffect } from 'react';
import './CreateBenefits.css';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const CreateBenefits = () => {
  const [benefitText, setBenefitText] = useState('');
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();
  const { planId,benefitText: initialBenefitText, benefitId } = location.state || {};
  const token = localStorage.getItem('auth-token');
  console.log(location.state)
  useEffect(() => {
    if (planId && initialBenefitText) {
      setIsEditMode(true);
      setBenefitText(initialBenefitText);
    }
  }, [planId, initialBenefitText]);
  

  const handleInputChange = (e) => {
    setBenefitText(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (benefitText.trim() === '') {
      alert('Please enter a benefit before submitting!');
      return;
    }

    setLoading(true);
    setError(null);
    let apiUrl = `${process.env.REACT_APP_API_ADMIN_SAVE_PLAYING_PLAN_BENEFIT}/${planId || ''}`;
    if (benefitId) {
      apiUrl += `?benefitId=${benefitId}`;
    }
    
    
    const headers = {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json',
    };

    const body = JSON.stringify({
      benefit: benefitText,
      ...(isEditMode && { planId })
    });

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers,
        body,
      });

      const data = await response.json();

      if (response.ok && data.success) {
        setBenefitText('');
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: isEditMode ? 'Benefit updated successfully!' : 'Benefit submitted successfully!',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
        navigate(-1); 
      } else {
        setError(data.message || 'Failed to submit the benefit.');
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: data.message || 'Failed to submit the benefit.',
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000,
        });
      }

    } catch (err) {
      setError('An error occurred while submitting the benefit.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="enrollment-container">
      <div className="breadcrumb">
        <Link to="/planList" className="breadcrumb-link">Plan List</Link> &gt; {isEditMode ? 'Edit Benefit' : 'New Benefit'}
      </div>

      <h2>{isEditMode ? 'Edit Your Benefit Plan' : 'Create Your Benefit Plan'}</h2>

      <div className="input-container">
        <input
          type="text"
          placeholder={isEditMode ? "Edit your plan benefit..." : "Enter your plan benefit..."}
          value={benefitText}
          onChange={handleInputChange}
          className="benefit-input"
        />
      </div>

      <div className="submit-container">
        <button onClick={handleSubmit} className="submit-button" disabled={loading}>
          {loading ? 'Submitting...' : (isEditMode ? 'Update Benefit' : 'Submit Your Plan')}
        </button>
      </div>

      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default CreateBenefits;
